export class SearchCondition {
    public sdate: string
    public noApp: boolean
}
